export default __webpack_public_path__ + "static/media/HRCr.8bda7efe.png";